/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetLogs.vue?vue&type=template&id=0f47519c&scoped=true&"
import script from "./packetLogs.vue?vue&type=script&lang=js&"
export * from "./packetLogs.vue?vue&type=script&lang=js&"
import style0 from "./packetLogs.vue?vue&type=style&index=0&id=0f47519c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47519c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
